import React from 'react';
import { Link } from 'react-router-dom';



export default function footer() {
  return (
     <div className="container-fluid footer_bg py-5">
  <div className="container animate-box">
    <div className="row">
      <div className="col-12 d-none d-md-flex justify-content-end mb-4">
        <img
          src="/images/logo.png"
          alt="Logo"
          className="img-fluid footer_logo"
        />
      </div>
      <div className="col-12 col-md-4 col-lg-3 mb-4 mb-md-0">
        <h5 className="footer_main_title py-3">About</h5>
        <p className="footer_sub_about">
          Welcome to India's Religious Destination. We provide complete
          information regarding Sanatana Dharma's Sacred sites for Pilgrimage
          and auspicious Tithi's.
        </p>
        <div className="social-icons d-flex flex-wrap">
          <a
            href="mailto:tirthyatras@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/images/gmail.png"
              alt="Gmail-TirthYatras"
              className="clickable-image"
            />
          </a>
          <a
            href="https://www.youtube.com/channel/UCnxB-xEGtlkOt2adk1voSow"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/images/youtube.png"
              alt="Youtube-TirthYatras"
              className="clickable-image"
            />
          </a>
          <a
            href="https://www.instagram.com/tirthyatras/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/images/instagram.png"
              alt="Instagram-TirthYatras"
              className="clickable-image"
            />
          </a>
          <a
            href="https://www.facebook.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/images/facebook.png"
              alt="Gmail-TirthYatras"
              className="clickable-image"
            />
          </a>
          <a
            href="https://play.google.com/store/apps?hl=en"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/images/playstore.png"
              alt="Gmail-TirthYatras"
              className="clickable-image"
            />
          </a>
        </div>
      </div>
      <div className="col-12 col-md-3 col-lg-2 mb-4 mb-md-0">
        <h5 className="footer_main_title py-3">Category</h5>
        <ul className="footer_menu list-unstyled">
          <li>
            <Link to="/ap/tirupati">
              <i className="fa fa-angle-right" /> Andhra Pradesh
            </Link>
          </li>
          <li>
            <Link to="/mh/Shirdi">
              <i className="fa fa-angle-right" /> Maharashtra
            </Link>
          </li>
          <li>
            <Link to="/kt/dharmastala">
              <i className="fa fa-angle-right" /> Karnataka
            </Link>
          </li>
          <li>
            <Link to="/tn/arunachalam">
              <i className="fa fa-angle-right" /> Tamilnadu
            </Link>
          </li>
          <li>
            <Link to="/ni/uttarakand">
              <i className="fa fa-angle-right" /> North India
            </Link>
          </li>
          <li>
            <Link to="/More/stotras">
              <i className="fa fa-angle-right" /> More
            </Link>
          </li>
        </ul>
      </div>
      <div className="col-12 col-md-2 d-none d-md-flex align-items-center justify-content-center mb-4 mb-md-0">
        <img
          src="/images/footer_sub_tipik.png"
          alt="Decorative"
          className="img-fluid width_footer_sub_img"
        />
      </div>
      <div className="col-12 col-md-5 col-lg-3">
        <h5 className="footer_main_title py-3">Most Viewed Posts</h5>
        <p className="footer_makes_sub_font">MahaKumbh</p>
        <a href="#" className="footer_post d-block pb-4">
          MahaKumbh Location and Last date to visit
        </a>
        <p className="footer_makes_sub_font">CharDham</p>
        <a href="#" className="footer_post d-block pb-4">
          Start of the Kedarnath Yatra and Registration
        </a>
        <p className="footer_makes_sub_font">Chardham</p>
        <a href="#" className="footer_post d-block pb-4">
          Start of the Barinath Yatra and Registration
        </a>
      </div>
    </div>
  </div>
  <div className="container-fluid footer_right_reserved py-3">
    <div className="container">
      <div className="row">
        <div className="col-md-6 text-white text-center text-md-left">
          © Copyright 2025, All rights reserved. Design by TirthYatras
        </div>
        <div className="col-md-6 text-center text-md-right">
          <a href="/index.html" className="footer_last_part_menu">
            Home
          </a>
          <a href="#" className="footer_last_part_menu">
            About
          </a>
          <a href="#" className="footer_last_part_menu">
            Contact
          </a>
          <a href="#" className="footer_last_part_menu">
            Latest News
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

  )
}
